import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React, { useCallback, useContext } from "react";
import { emitUpsellNudgeAction } from "@catchoftheday/analytics";
import { Box, Button, Carousel, Flex, Heading, IconBellRinging, IconMemberDiscount, IconOnePass, IconOnePassDelivery, IconOnePassTags, Link, Span, Text } from "@catchoftheday/cg-components";
import { CustomerContext } from "@catchoftheday/customer";
import { OnePassConfigurationContext, triggerOnePassUpsellModal } from "@catchoftheday/onepass";
import { formatPrice } from "@catchoftheday/utilities";
import { BenefitCard } from "./BenefitCard";
import { jsx as ___EmotionJSX } from "@emotion/react";
var sharedIconProps = {
  role: "img",
  width: "auto",
  color: "onePass.primaryDark"
};

var FreeDeliveryIcon = ___EmotionJSX(IconOnePassDelivery, _extends({
  title: "Free delivery",
  height: {
    xs: "30px",
    md: "43px"
  },
  mt: "10px",
  ml: "12px"
}, sharedIconProps));

var MemberDiscountIcon = ___EmotionJSX(IconMemberDiscount, _extends({
  title: "Member only pricing",
  height: {
    xs: "41px",
    md: "59px"
  },
  ml: "10px",
  mt: {
    xs: "5px",
    md: "0"
  }
}, sharedIconProps));

var ExclusiveDealsIcon = ___EmotionJSX(IconOnePassTags, _extends({
  title: "Exclusive deals",
  height: {
    xs: "42px",
    md: "57px"
  },
  ml: "12px",
  mt: {
    xs: "5px",
    md: "0"
  }
}, sharedIconProps));

var EarlyAlertsIcon = ___EmotionJSX(IconBellRinging, _extends({
  title: "Early alerts",
  height: {
    xs: "42px",
    md: "50px"
  },
  ml: "6px",
  mt: {
    xs: "5px",
    md: "0"
  }
}, sharedIconProps));

export var STATIC_BENEFITS = [{
  icon: FreeDeliveryIcon,
  title: "Free delivery",
  desc: "On eligible items or orders at Catch, Kmart, Target, Bunnings Warehouse and Officeworks"
}, {
  icon: MemberDiscountIcon,
  title: "Member only prices",
  desc: "Member prices on thousands of products at Catch"
}, {
  icon: ExclusiveDealsIcon,
  title: "Exclusive deals",
  desc: "Access to exclusive weekly deals at Catch"
}, {
  icon: EarlyAlertsIcon,
  title: "Early alerts",
  desc: "Get priority alerts to the best deals at Catch"
}];
export var ShopMemberBenefits = function ShopMemberBenefits() {
  var _membership$subscript, _membership$subscript2, _globalThis$cotd, _onePassConfig$priceM, _onePassConfig$priceY;

  var _useContext = useContext(OnePassConfigurationContext),
      onePassConfig = _useContext.data;

  var _useContext2 = useContext(CustomerContext),
      customerData = _useContext2.data,
      loading = _useContext2.loading;

  var _ref = customerData || {},
      club = _ref.club,
      membership = _ref.membership;

  var isClubCatchLapsed = !(club !== null && club !== void 0 && club.active) && !(membership !== null && membership !== void 0 && membership.linked) && !(club !== null && club !== void 0 && club.freeTrialEligible);
  var isFreeTrialEligible = !membership || (membership === null || membership === void 0 ? void 0 : (_membership$subscript = membership.subscription) === null || _membership$subscript === void 0 ? void 0 : _membership$subscript.freeTrialEligible);
  var showFreeTrial = !customerData || isFreeTrialEligible || isClubCatchLapsed;
  var buttonText = "JOIN ONEPASS TODAY";
  if (showFreeTrial) buttonText = "START FREE ".concat(onePassConfig === null || onePassConfig === void 0 ? void 0 : onePassConfig.trialLength, " DAY TRIAL");
  var handleUpsellCTAClick = useCallback(function () {
    triggerOnePassUpsellModal();
    emitUpsellNudgeAction(isFreeTrialEligible ? "freeTrial" : "join");
  }, [isFreeTrialEligible]);
  if (loading || club !== null && club !== void 0 && club.active || membership !== null && membership !== void 0 && (_membership$subscript2 = membership.subscription) !== null && _membership$subscript2 !== void 0 && _membership$subscript2.active) return null;
  return ___EmotionJSX(Box, {
    py: {
      xs: "24px",
      md: "36px"
    },
    px: {
      xs: "10px",
      md: "45.5px"
    },
    backgroundColor: "#F4E7FF",
    "data-testid": "banner-shopMemberBenefits"
  }, ___EmotionJSX(Heading.h2, {
    as: "h3",
    fontSize: {
      xs: "base",
      md: "2xl"
    },
    lineHeight: {
      xs: "24px",
      md: "32px"
    },
    color: "onePass.textPrimary",
    mt: {
      md: "24px"
    },
    mb: 0,
    fontWeight: "normal",
    textAlign: "center"
  }, ___EmotionJSX(IconOnePass, {
    title: "OnePass",
    color: "onePass.primary",
    height: {
      xs: "16px",
      md: "25px"
    },
    width: "auto",
    mt: "-8px",
    ml: {
      xs: "4px",
      md: "9px"
    }
  })), ___EmotionJSX(Text, {
    color: "onePass.textPrimary",
    textAlign: "center",
    fontWeight: "semibold",
    fontSize: {
      xs: "sm",
      md: "base"
    },
    mb: {
      xs: "24px",
      md: "36px"
    },
    mt: {
      md: "6px"
    }
  }, "Your pass to free delivery on thousands of eligible items or orders across Catch, Kmart, Target, Bunnings Warehouse and Officeworks."), ___EmotionJSX(Carousel, {
    containerProps: {
      maxWidth: "1190px",
      margin: "0 auto"
    },
    slides: STATIC_BENEFITS.map(function (benefit, index) {
      return ___EmotionJSX(BenefitCard, _extends({
        key: "club-benefit-".concat(index)
      }, benefit));
    }),
    slidesPerBreakpoint: [4, 4, 2, 2, 2],
    showNavButtons: false,
    showBullets: globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$cotd = globalThis.cotd) === null || _globalThis$cotd === void 0 ? void 0 : _globalThis$cotd.isMobileWeb
  }), ___EmotionJSX(Flex, {
    mt: {
      xs: "14px",
      md: "36px"
    },
    flexDirection: "column",
    alignItems: "center"
  }, ___EmotionJSX(Button, {
    width: "auto",
    sizeVariant: "md",
    variant: "onePassPrimary",
    mb: "8px",
    px: "24px",
    py: "11px",
    lineHeight: "20px",
    onClick: handleUpsellCTAClick
  }, buttonText), ___EmotionJSX(Link, {
    href: "/onepass",
    fontSize: "xs",
    fontWeight: "bold",
    lineHeight: "20px",
    color: "onePass.primary",
    hoverColor: "onePass.primary",
    textDecoration: "underline",
    fontFamily: "onePass"
  }, "Learn More"), ___EmotionJSX(Span, {
    fontSize: "2xs",
    textAlign: "center",
    mt: "8px"
  }, !customerData || isFreeTrialEligible ? "After your ".concat(onePassConfig === null || onePassConfig === void 0 ? void 0 : onePassConfig.trialLength, " day free trial, ") : "", "OnePass is only", " ", formatPrice(onePassConfig === null || onePassConfig === void 0 ? void 0 : (_onePassConfig$priceM = onePassConfig.priceMonthly) === null || _onePassConfig$priceM === void 0 ? void 0 : _onePassConfig$priceM.amount, false), "/month or you can save more at", " ", formatPrice(onePassConfig === null || onePassConfig === void 0 ? void 0 : (_onePassConfig$priceY = onePassConfig.priceYearly) === null || _onePassConfig$priceY === void 0 ? void 0 : _onePassConfig$priceY.amount, false), "/year. Cancel anytime.")));
};